import { deleteData, getData } from '../utils/db'

/** One remembered pair: this target field was filled from that source field. */
export type TMappingHint = {
    _id: string
    /** As written, e.g. 'Email' — never the normalised form the memory searches by. */
    target: string
    source: string
    /** How often it was assigned this way, and how often such a suggestion was turned into something else. */
    hits: number
    rejects: number
    lastUsedAt: string
}

/**
 * The learned field assignments of the signed-in user's tenant.
 *
 * Only ever the tenant's own — suggestions draw on what everybody learned, but
 * this list, and deleting from it, stops at the tenant boundary.
 */
export default class MappingHintsModel {
    public async list(): Promise<{ data: TMappingHint[] } | undefined> {
        return await getData('/mapping-hints')
    }

    public async remove(id: string) {
        return await deleteData(`/mapping-hints/${id}`)
    }
}
